<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <div class="card-title w-100 p-2 mb-0">
          <div class="row align-items-center">
            <div class="col-xl-3 col-12" ngClass.md="mb-1" ngClass.sm="mb-1">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="search()" />
            </div>
            <div class="col-xl-3 col-12" ngClass.md="mb-1" ngClass.sm="mb-1">
              <div class="d-flex">
                <label for="monthYear" class="mb-0" ngClass.md="flex-basis-66" ngClass.sm="flex-basis-66">
                  <select [(ngModel)]="selectedMonth" (ngModelChange)="loadData()" id="monthYear" class="form-control pr-3 text-capitalize">
                    <option selected disabled value="all">{{ "MONTH" | translate }}</option>
                    <option *ngFor="let month of availableMonths" [value]="month" [label]="formatLabel(month)">{{ month }}</option>
                  </select>
                </label>
                <label for="years" class="mb-0 ml-1" ngClass.md="flex-basis-33" ngClass.sm="flex-basis-33">
                  <select id="years" [(ngModel)]="selectedYear" (change)="loadData()" class="form-control pr-3">
                    <option selected disabled value="all">{{ "YEAR" | translate }}</option>
                    <option *ngFor="let year of availableYears">{{ year }}</option>
                  </select>
                </label>
              </div>
            </div>
            <div class="col-xl-6 text-right col-12" ngClass.md="mb-1">
              <button class="btn btn-outline-primary" has_capability="create_structure_cost" (click)="openModal(costModal, null, null)">
                {{ "ADD" | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="card-body p-0 overflow-hidden">
          <ngx-datatable #table class="bootstrap core-bootstrap material expandable" columnMode="force" [headerHeight]="30"
                         [footerHeight]="0" [rowHeight]="_utilService.isDesktop ? 50 : 150" [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }" [scrollbarH]="true" [limit]="1000" [rows]="filterStructureCostList">
            <!-- Row Detail Template -->
            <ngx-datatable-row-detail [rowHeight]="0" #myDetailRow>
              <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
                <div class="child-datatable">
                  <div class="row" *ngFor="let child of row.children; let i = index" [ngClass]="i < row.children.length - 1 ? 'mb-1' : ''">
                    <div class="col-lg-3 pr-0" ngClass.sm="pl-0">
                      <span>{{ "FROM" | translate }} {{ _utilService.formatDate(child.from) }}{{ child.to ? " " + ("TO" | translate) + " " + _utilService.formatDate(child.to) : "" }}</span>
                    </div>
                    <div class="col-lg-3 px-0" ngClass.sm="order-first">
                      <a *ngIf="child?.user?.complete_name" target="_blank" routerLink="/dashboard/user/profile/{{ child?.user?.user_hash }}">{{ child?.user?.complete_name }}</a>
                      <div *ngIf="child?.commissions_number && child?.commissions_number != '0' && child?.commissions_number != '1'" class="commission-number">{{ child?.commissions_number }}</div>
                      <div *ngIf="!child?.user?.complete_name">-</div>
                    </div>
                    <div class="col-lg-2 pl-0">
                      <span *ngIf="_utilService.isMobile">{{ "ESTIMATED_COST" | translate }}</span>
                      <span>{{ (child?.estimate_amount || "0") | currency: 'EUR'  }}</span>
                    </div>
                    <div class="col-lg-2 pl-0">
                      <span *ngIf="_utilService.isMobile">{{ "EFFECTIVE_COST" | translate }}</span>
                      <span>{{ child?.amount | currency: 'EUR' }}</span>
                    </div>
                    <div class="col-lg-2 pl-0 actions" ngClass.sm="text-right mr-1">
                      <button class="bg-transparent border-0 text-warning" (click)="reloadEmployeeCost(child.id)" placement="left" [ngbTooltip]="'RELOAD_STRUCTURE_COSTS' | translate" has_capability="edit_structure_cost">
                        <span [data-feather]="'refresh-cw'" size="16" class="mr-50"></span>
                      </button>
                      <button class="bg-transparent border-0 text-secondary" container="body" (click)="openModal(costModal, child, row)" [ngbTooltip]="'EDIT' | translate"
                              has_capability="edit_structure_cost">
                        <span [data-feather]="'edit-2'" size="16" class="mr-50"></span>
                      </button>
                      <button class="bg-transparent border-0 text-danger" (click)="delete(child)" container="body" [ngbTooltip]="'DELETE' | translate" has_capability="delete_structure_cost">
                        <span [data-feather]="'trash-2'" size="16"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-row-detail>
            <!-- Column Templates -->
            <ngx-datatable-column [width]="50" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
              <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
                <a *ngIf="row.children && row.children.length > 0" href="javascript:void(0)" [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row, expanded)">
                </a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'DESCRIPTION' | translate" prop="description" *ngIf="_utilService.isDesktop" [width]="195">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="text-break-line-2" [ngbTooltip]="row.description">{{ row.description }}</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TITLES.USERS_TYPES_SINGULAR.employee' | translate" [sortable]="false" *ngIf="_utilService.isDesktop" [width]="200">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span *ngIf="row.user && !row?.user.complete_name && row?.children && row.children.length > 0" [ngbTooltip]="row?.employees_names_formatted ? row?.employees_names_formatted : null">
                  <i [data-feather]="row.children.length > 1 ? 'users' : 'user'" size="19"></i>
                </span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ESTIMATED_COST' | translate" prop="estimate_amount" *ngIf="_utilService.isDesktop" [width]="90">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div>{{ _utilService.addDotsToNumber(row.estimate_amount || "0") }} €</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'EFFECTIVE_COST' | translate" prop="amount" *ngIf="_utilService.isDesktop" [width]="90">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div>{{ _utilService.addDotsToNumber(row.amount) }} €</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop" [width]="100">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex">
                  <button class="bg-transparent border-0 text-success" (click)="openModal(costModal, null, row)" [ngbTooltip]="'ADD' | translate" has_capability="create_structure_cost">
                    <span [data-feather]="'plus'" size="16" class="mr-50"></span>
                  </button>
                  <button class="bg-transparent border-0 text-secondary" (click)="openModal(costModal, row, null)" [ngbTooltip]="'EDIT' | translate" has_capability="edit_structure_cost">
                    <span [data-feather]="'edit-2'" size="16" class="mr-50"></span>
                  </button>
                  <button class="bg-transparent border-0 text-danger" (click)="delete(row)" [ngbTooltip]="'DELETE' | translate" has_capability="delete_structure_cost">
                    <span [data-feather]="'trash-2'" size="16"></span>
                  </button>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!-- mobile - tablet -->
            <ngx-datatable-column [name]="'TITLES.USERS_TYPES_SINGULAR.employee' | translate" prop="user.complete_name" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12 pl-0">
                    <div>
                      <span>{{ "TITLES.USERS_TYPES.employee" | translate }}: </span>
                      <span>{{ row.children.length }}</span>
                    </div>
                    <div>
                      <span>{{ "DESCRIPTION" | translate }}: </span>
                      <span>{{ row.description }}</span>
                    </div>
                    <div>
                      <span>{{ "ESTIMATED_COST" | translate }}: </span>
                      <span>{{ _utilService.addDotsToNumber(row.estimate_amount || "0") }} €</span>
                    </div>
                    <div>
                      <span>{{ "EFFECTIVE_COST" | translate }}: </span>
                      <span>{{ _utilService.addDotsToNumber(row.amount) }} €</span>
                    </div>
                  </div>
                  <div class="col-12 mt-075 text-right">
                    <button class="bg-transparent border-0 text-success" (click)="openModal(costModal, null, row)" [ngbTooltip]="'ADD' | translate" has_capability="create_structure_cost">
                      <span [data-feather]="'plus'" size="16" class="mr-50"></span>
                    </button>
                    <button class="bg-transparent border-0 text-secondary" (click)="openModal(costModal, row, null)" [ngbTooltip]="'EDIT' | translate" has_capability="edit_structure_cost">
                      <span [data-feather]="'edit-2'" size="16" class="mr-50"></span>
                    </button>
                    <button class="bg-transparent border-0 text-danger" (click)="delete(row)" [ngbTooltip]="'DELETE' | translate" has_capability="delete_structure_cost">
                      <span [data-feather]="'trash-2'" size="16"></span>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
          <div class="row">
            <div class="col-12 px-0 border-top pt-1 pb-2">
              <div class="row" *ngIf="_utilService.isDesktop">
                <div class="col-6 pl-4">
                  <div class="pl-4">
                    <strong>{{ "TOTAL" | translate }}</strong>
                  </div>
                </div>
                <div class="col-2 pl-2">
                  <div class="ml-05" [ngbTooltip]="'ESTIMATED_COST' | translate">
                    <strong>{{ _utilService.addDotsToNumber(totalEstimateAmount) }}€</strong>
                  </div>
                </div>
                <div class="col-2">
                  <div [ngbTooltip]="'EFFECTIVE_COST' | translate">
                    <strong>{{ _utilService.addDotsToNumber(totalRealAmount) }}€</strong>
                  </div>
                </div>
              </div>
              <div class="row px-2" *ngIf="!_utilService.isDesktop">
                <div class="px-1 ml-1 col-12">
                  <strong>{{ "ESTIMATED_COST" | translate }}</strong>:&nbsp;
                  <span>{{ _utilService.addDotsToNumber(totalEstimateAmount) }}€</span>
                </div>
                <div class="px-1 ml-1 col-12">
                  <strong>{{ "EFFECTIVE_COST" | translate }}</strong>:&nbsp;
                  <span>{{ _utilService.addDotsToNumber(totalRealAmount) }}€</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Modal Cost -->
<ng-template #costModal let-modal>
  <form [formGroup]="formGroup">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modalClose()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>
        {{
          !editMode && !isSelectedAChild
            ? ("ADD_NEW_COST" | translate)
            : !editMode && isSelectedAChild
              ? ("ADD_NEW_BELOW_COST" | translate)
              : editMode && !isSelectedAChild
                ? ("EDIT_COST" | translate)
                : ("EDIT_BELOW_COST" | translate)
        }}
      </h3>
      <div class="row">
        <div class="form-group col-12">
          <label>{{ "TITLES.USERS_TYPES.employee" | translate }}:<sup class="text-danger">*</sup></label>
          <div class="cursor-pointer" *ngIf="selectedStructureCost && selectedStructureCost.user && selectedStructureCost.user.complete_name && !showEditField.user_hash" (click)="toggleField('user_hash')">
            {{ selectedStructureCost && selectedStructureCost.user && selectedStructureCost.user.complete_name ? selectedStructureCost.user.complete_name : "-" }}
          </div>
          <!-- Se non è presente un user significa che è un semplice contenitore quindi non ha il dipendente -->
          <div *ngIf="editMode && (!selectedStructureCost || !selectedStructureCost.user || !selectedStructureCost.user.complete_name)">-</div>
          <ng-select *ngIf="showEditField.user_hash" id="employees" bindLabel="complete_name" bindValue="hash" formControlName="user_hash"
                     [multiple]="true" [searchable]="true" [closeOnSelect]="true" [hideSelected]="true" [ngClass]="{'is-invalid': formHasError('user_hash')}"
                     [clearable]="false" [openOnEnter]="false" [virtualScroll]="false" [maxSelectedItems]="editMode ? 1 : 1000" [items]="employeesList"></ng-select>
          <div class="invalid-feedback" *ngIf="formGroup.controls.user_hash.errors?.required">{{ "ERRORS.EMPLOYEES_REQUIRED" | translate }}</div>
        </div>
        <div class="form-group col-12">
          <label for="to">{{ "DESCRIPTION" | translate }}<sup class="text-danger">*</sup></label>
          <div class="cursor-pointer" *ngIf="isSelectedAChild || (selectedStructureCost && selectedStructureCost.description && !showEditField.description)" (click)="toggleField('description')">
            {{ selectedStructureCost && selectedStructureCost.description ? selectedStructureCost.description : selectedParent && selectedParent.description ? selectedParent.description : "-" }}
          </div>
          <textarea *ngIf="showEditField.description && !isSelectedAChild" id="description" [placeholder]="'DESCRIPTION' | translate" type="text" class="form-control {{ formHasError('description') ? 'is-invalid' : null }}" formControlName="description"></textarea>
          <div class="invalid-feedback" *ngIf="formGroup.controls.description.errors?.required">{{ "ERRORS.FIELD_DESCRIPTION" | translate }}</div>
        </div>
        <div class="form-group col-12" *ngIf="selectedStructureCost && selectedStructureCost.amount && !showEditField.amount">
          <label for="to">{{ "AMOUNT" | translate }}</label>
          <div class="cursor-pointer" (click)="toggleField('amount')">{{ _utilService.addDotsToNumber(selectedStructureCost.amount) }} €</div>
        </div>
        <div class="form-group col-12">
          <label [for]="'from'">{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
          <div class="cursor-pointer" *ngIf="selectedStructureCost && selectedStructureCost.from && !showEditField.from && selectedStructureCost.user && selectedStructureCost.user.complete_name" (click)="toggleField('from')">
            {{ _utilService.formatDate(selectedStructureCost.from) }}
          </div>
          <!-- Se non è presente un user significa che è un semplice contenitore quindi non ha la data -->
          <div *ngIf="editMode && (!selectedStructureCost || !selectedStructureCost.user || !selectedStructureCost.user.complete_name)">-</div>
          <app-datepickr *ngIf="showEditField.from" id="from" [defaultDate]="formGroup.value.from" (onSelect)="formGroup.patchValue({from: $event})" [minDate]="minDateSelectedMonth" [maxDate]="maxDateSelectedMonth" [isInvalid]="!formGroup.value.from && showErrors"></app-datepickr>
          <div class="invalid-date" *ngIf="!formGroup.value.from && showErrors">{{ "ERRORS.INSERT_FROM" | translate }}</div>
        </div>
        <div class="form-group col-12">
          <label [for]="'to'">{{ "TO" | translate }}</label>
          <div class="cursor-pointer" *ngIf="selectedStructureCost && !showEditField.to && selectedStructureCost.user && selectedStructureCost.user.complete_name" (click)="toggleField('to')">
            {{ selectedStructureCost && selectedStructureCost.to ? _utilService.formatDate(selectedStructureCost.to) : "-" }}
          </div>
          <!-- Se non è presente un user significa che è un semplice contenitore quindi non ha la data -->
          <div *ngIf="editMode && (!selectedStructureCost || !selectedStructureCost.user || !selectedStructureCost.user.complete_name)">-</div>
          <app-datepickr *ngIf="showEditField.to" id="to" [defaultDate]="formGroup.value.to" (onSelect)="formGroup.patchValue({to: $event})" [minDate]="minDateSelectedMonth" [isInvalid]="!formGroup.value.to && showErrors"></app-datepickr>
          <div class="invalid-date" *ngIf="!formGroup.value.to && showErrors">{{ "ERRORS.INSERT_TO" | translate }}</div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()" rippleEffect>
        {{ "BACK" | translate }}
      </button>
      <button type="button" class="btn btn-primary w-150" (click)="!editMode ? addNewCost($event) : editCost($event)" [disabled]="clicked" *ngIf="showEditField.user_hash || showEditField.from || showEditField.to || showEditField.description">
        {{ "SAVE" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Cost -->
